import {FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";

export const repeatPasswordValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const newPassword1 = control.get('new_password_1');
  const newPassword2 = control.get('new_password_2');

  return newPassword1.value !== newPassword2.value ? { new_password_1: true, new_password_2: true } : null;
};
